import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingSpinner = ({ message = 'Loading...', size = 'md', fullPage = false }) => {
  const spinnerSize = size === 'sm' ? 'sm' : size === 'lg' ? 'lg' : undefined;
  
  if (fullPage) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <Spinner animation="border" role="status" size={spinnerSize} className="mb-3">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        {message && <p className="text-muted">{message}</p>}
      </div>
    );
  }
  
  return (
    <div className="text-center my-4">
      <Spinner animation="border" role="status" size={spinnerSize} className="mb-2">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      {message && <p className="text-muted small">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
